import {Injectable} from '@angular/core';
import {ApiRequestService} from './api-request.service';
import {AppConfig} from '../../app-config';
import {Observable, BehaviorSubject, Subject} from 'rxjs';
import {HttpParams} from '@angular/common/http';
import {Client} from '../../pages/user-management/client/client.model';

export interface ClientRequestParam {
    id: number;
    name: string;
    partyTypeId: number;
    createdOn: string;
    statusId: number;
    status: string;

}

@Injectable()
export class ClientService {

    constructor(private apiRequest: ApiRequestService,
                private appConfig: AppConfig) {
    }
    // fetch All Client
    getAllClient(pageNumber: any, limit: any): Observable<any> {
        const me = this;
        const vendorListSubject = new Subject<any>(); // Will use this subject to emit data that we want
        let params: HttpParams = new HttpParams();
        params = params.append('p', pageNumber);
        params = params.append('l', limit);
        me.apiRequest.get(this.appConfig.client_url + '/1/parties', params).subscribe(jsonResp => {
            const items = jsonResp.data.map(function (v) {
                return Object.assign({}, v, {
                    id: `${v.id}`,
                    name: `${v.name}`,
                    partyTypeId: `${v.partyTypeId}`,
                    statusId: `${v.statusId}`,
                    status: `${v.status}`,
                });
            });

            const coldObj = Object.assign({}, jsonResp, {
                data: items
            });
            vendorListSubject.next(coldObj); // incidentList is a Subject and emits an event thats being listened to by the components
        });
        return vendorListSubject;
    }
    // save parties
    save(client: Client): Observable<any> {
        const me = this;

        const bodyData: ClientRequestParam = <ClientRequestParam> {
            'partyTypeId': 1,
            'name': client.name

        };

        const clientDataSubject: BehaviorSubject<any> = new BehaviorSubject<any>([]); // Will use this BehaviorSubject to emit data that we want after ajax login attempt

        me.apiRequest.post(this.appConfig.parties_url, bodyData)
            .subscribe(jsonResp => {
                    let clientInfoReturn: ClientRequestParam;
                    if (jsonResp !== undefined && jsonResp !== null && jsonResp.success === 'true' && jsonResp.data.length !== 0) {
                        const client: Client = jsonResp.data[0];

                        clientInfoReturn = <ClientRequestParam>{
                            'partyTypeId': 1,
                            'name': client.name
                        };

                    } else {
                        console.log('added:----:' + jsonResp.message);
                    }
                    clientDataSubject.next(clientInfoReturn);
                },
                err => {
                    console.log('added err:----:' + err);
                });

        return clientDataSubject;
    }
    // update parties
    update(client: Client, id: number): Observable<any> {
        const me = this;

        const bodyData = {
            'id': client.id,
            'name': client.name
        };

        const clientDataSubject: BehaviorSubject<any> = new BehaviorSubject<any>([]); // Will use this BehaviorSubject to emit data that we want after ajax login attempt

        me.apiRequest.put(this.appConfig.parties_url + '/' + id, bodyData)
            .subscribe(jsonResp => {
                    let clientInfoReturn: ClientRequestParam;
                    if (jsonResp !== undefined && jsonResp !== null && jsonResp.success === 'true' && jsonResp.data.length !== 0) {
                        const cc: Client = jsonResp.data[0];
                        clientInfoReturn =  <ClientRequestParam> {
                            'id': cc.id,
                            'name': cc.name,
                        };

                    } else {
                        console.log('updated :----:' + jsonResp.message);
                    }
                    clientDataSubject.next(clientInfoReturn);
                },
                err => {
                    console.log('update  err:----:' + err);
                });

        return clientDataSubject;
    }

    deleteClient(id: number): Observable<any> {
        const me = this;
        return me.apiRequest.delete(this.appConfig.parties_url + '/' + id);
    }

}
